import axios from 'axios';
// import { useLocale } from "use-intl";
import { VITE_API_HOST } from './const';

/**
 * Map frontend language codes to backend-supported language codes
 * Backend only supports: 'en' and 'zh'
 */
export const mapLanguageForBackend = (frontendLanguage: string): string => {
  // Map Chinese variants to 'zh'
  if (frontendLanguage === 'zh-CN' || frontendLanguage === 'zh') {
    return 'zh';
  }

  // All other languages default to 'en'
  return 'en';
};

export const apiClient = axios.create({
  baseURL: (VITE_API_HOST || '') + '/api',
  timeout: 0,
  withCredentials: true,
});

apiClient.interceptors.request.use(config => {
  // Get current language from localStorage, fallback to 'en'
  const currentLanguage = localStorage.getItem('vite-ui-language') || 'en';
  const mappedLanguage = mapLanguageForBackend(currentLanguage);
  config.headers['refer-language'] = mappedLanguage;
  config.headers['organization-id'] = localStorage.getItem('org_id');

  console.log('API Request:', {
    url: config.url,
    method: config.method,
    headers: config.headers,
    data: config.data,
  });

  return config;
});

apiClient.interceptors.response.use(
  response => {
    console.log('API Response:', {
      url: response.config.url,
      status: response.status,
      data: response.data,
    });
    return response;
  },
  error => {
    console.log('API Error:', {
      url: error.config?.url,
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    return Promise.reject(error);
  }
);
